module.exports = new __parcel__URL__("welcome-to-project-pages.7259f386.png").toString();